 
 
 
 
 
 
define(['../arrayMerge'], function(arrayMerge) {
    'use strict';

    var getFeature;
    var incidentCategories = {
        0: 'Unknown',
        1: 'Accident',
        2: 'Fog',
        3: 'Dangerous Conditions',
        4: 'Rain',
        5: 'Ice',
        6: 'Jam',
        7: 'Lane Closed',
        8: 'Road Closed',
        9: 'Road Works',
        10: 'Wind',
        11: 'Flooding',
        12: 'Detour',
        13: 'Cluster'
    };

    var incidentSeverities = {0: 'unknown', 1: 'minor', 2: 'moderate', 3: 'major', 4: 'undefined'};

    function newFeature(properties, type) {
        return {
            type: 'Feature',
            geometry: {type: type, coordinates: []},
            properties: properties
        };
    }

    function newFeatureCollection(properties) {
        var featureCollection = {
            type: 'FeatureCollection',
            features: []
        };
        if (properties) {
            featureCollection.properties = properties;
        }
        return featureCollection;
    }

    function setProperty(property, propertyName, properties) {
        if (property) {
            properties[propertyName] = property;
        }
    }

    getFeature = function(poi, preserveCluster) {
        var feature, i, properties = {};
        properties.id = poi.id;
        if (poi.cbl && poi.ctr) {
            properties.clusterBounds = [[poi.cbl.y, poi.cbl.x], [poi.ctr.y, poi.ctr.x]];
        }
        if (poi.op) {
            properties.originalPosition = [poi.op.y, poi.op.x];
        }
        if (poi.ic) {
            properties.incidentCategory = incidentCategories[poi.ic];
        }
        if (poi.ty) {
            properties.incidentSeverity = incidentSeverities[poi.ty];
        }
        setProperty(poi.cs, 'clusterSize', properties);
        setProperty(poi.d, 'description', properties);
        setProperty(poi.c, 'incidentCause', properties);
        setProperty(poi.f, 'from', properties);
        setProperty(poi.t, 'to', properties);
        setProperty(poi.r, 'roadNumber', properties);
        setProperty(poi.dl, 'delaySeconds', properties);
        setProperty(poi.l, 'lengthMeters', properties);
        if (poi.cpoi && !preserveCluster) {
            properties.clusterCoordinates = [poi.p.x, poi.p.y];
            feature = newFeatureCollection(properties);
            for (i = 0; i < poi.cpoi.length; i += 1) {
                feature.features.push(getFeature(poi.cpoi[i], false));
            }
        } else {
            if (poi.cpoi) {
                properties.features = poi.cpoi.map(getFeature);
            }
            feature = newFeature(properties, 'Point');
            feature.geometry.coordinates = [poi.p.x, poi.p.y];
        }
        return feature;
    };

    return function(preserveCluster) {
        return function(data) {
            var result = newFeatureCollection(null),
                json = data[0] || data,
                i;
            if (!json || !json.tm || !json.tm.poi) {
                return result;
            }
            if (data.length > 1) {
                // this is edge of the world case
                json.tm.poi = arrayMerge(data[0].tm.poi, data[1].tm.poi, function(first, second) {
                    return first.id === second.id;
                });
            }
            for (i = 0; i < json.tm.poi.length; i += 1) {
                result.features.push(getFeature(json.tm.poi[i], preserveCluster));
            }
            return result;
        };
    };
})
;



// WEBPACK FOOTER //
// ./model/traffic/trafficIncidents.js